import React from 'react'
import { ChartCard } from './AIChartParts'
import AIHorizontalBars from './AIHorizontalBars'
import { providerColor, providerLabel, num } from './aiCostFormat'

const TOP = 10

/** Top models by cost */
const AIModelBreakdown = ({ models = [], isLoading, error }) => {
  const top = models.slice(0, TOP)
  return (
    <ChartCard
      title="Cost by Model"
      subtitle={models.length > TOP ? `Top ${TOP} of ${models.length}` : null}
      isLoading={isLoading}
      error={error}
      isEmpty={!models.length}
    >
      <AIHorizontalBars
        rows={top.map((m) => ({
          label: m.model,
          cost: m.cost,
          requests: m.requests,
          color: providerColor(m.provider),
          extra: [
            { label: 'Provider', value: providerLabel(m.provider) },
            { label: 'Audio minutes', value: num(m.audioMinutes, 1) },
          ],
        }))}
      />
    </ChartCard>
  )
}

export default AIModelBreakdown
